import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiService } from '@shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  public imgURL: string;
  public imageError: string;

  constructor(private http: HttpClient,
              private apiService: ApiService) { }

  loginImgur(refreshToken: any, clientId: any, clientSecret: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});

    return this.http.post('https://api.imgur.com/oauth2/token',
      {
        refresh_token: refreshToken,
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: 'refresh_token'
      }, {headers: headers});
  }

  postImage(image: any, token: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    headers.set('Authorization', 'Client-ID ' + token);

    return this.http.post('https://api.imgur.com/3/upload', {image: image}, {headers: headers});
  }

  getProductImage(productId) {
    return this.apiService.get('files/' + productId + '/downloadFile').toPromise();
  }

  getProductImageError(productId){
    let errorLoading = false;
    this.apiService.get('files/' + productId + '/downloadFile').subscribe({ next: (data) =>{
      errorLoading = data;
      },
      error: (error) => {
        console.error(error.error, error.status);
        errorLoading = false;
      }});
    return errorLoading;
  }
}
